export class ProposalConst {
    public static readonly noAnswerDefaultText: string = 'Unknown';
}

export class MfHkAddressValidation {
    static readonly forbiddenAnywherePattern: RegExp = /[|"\r\n]/;
    static readonly forbiddenAtEdgesPattern: RegExp = /^['\/\\]|['\/\\]$/;

    static hasInvalidChars(value: string | null | undefined): boolean {
        if (!value) return false;
        return this.forbiddenAnywherePattern.test(value) || this.forbiddenAtEdgesPattern.test(value);
    }

    static isEmailValid(email: string): boolean {
        return /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(email);
    }
}
